import serializable from "../common/decorators/serializable";
import { EntityFirebase } from "../common/entity.firebase";

export enum Permission {
    SELL = 'SELL',
    READ_SALES_ANALYTICS = 'READ_SALES_ANALYTICS',
    WRITE_PRODUCTS = 'WRITE_PRODUCTS',
    READ_WRITE_PRODUCTS_PRIVATE = 'READ_WRITE_PRODUCTS_PRIVATE',
    ADMIN = 'ADMIN',
    CASH_REGISTER_MANAGEMENT = 'CASH_REGISTER_MANAGEMENT',
    ACCOUNTS_PAYABLE = 'ACCOUNTS_PAYABLE',
    MANAGE_CUSTOMERS = 'MANAGE_CUSTOMERS',
    ALLOW_CREDIT_SALE = 'ALLOW_CREDIT_SALE',
};

export const permissionsLabel = {
    [Permission.SELL]: 'Vendas',
    [Permission.READ_SALES_ANALYTICS]: 'Estatísticas',
    [Permission.WRITE_PRODUCTS]: 'Produtos',
    [Permission.READ_WRITE_PRODUCTS_PRIVATE]: 'Dados privados',
    [Permission.ADMIN]: 'Administrador',
    [Permission.CASH_REGISTER_MANAGEMENT]: 'Caixa',
    [Permission.ACCOUNTS_PAYABLE]: 'Contas a pagar',
    [Permission.MANAGE_CUSTOMERS]: 'Clientes',
    [Permission.ALLOW_CREDIT_SALE]: 'Venda fiado',
}


@serializable
export class User extends EntityFirebase {
    constructor(
        public readonly id: string,
        public email: string,
        public name: string,
        public permissions: Permission[],
        /**
         * Percentual de comissão só para este usuário (0–100).
         * `null` = usar o percentual padrão em Configurações.
         */
        public commissionPercent: number | null = null,
    ) {
        super();
    }

    static async build(id: string, data: any) {
        let commission: number | null = null;
        if (typeof data.commissionPercent === "number" && !Number.isNaN(data.commissionPercent)) {
            commission = Math.min(100, Math.max(0, data.commissionPercent));
        }
        return new this(
            id,
            data.email || "",
            data.name,
            data.permissions,
            commission,
        );;
    }

    hasPermission(permission: Permission|Permission[]) {
        if (Array.isArray(permission)) {
            return permission.some(p => this.permissions.includes(p));
        }

        return this.permissions.includes(permission);
    }
}
